export const getHomePageComponent =
    (component: keyof typeof import('./home-page.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "home-page" */
            './home-page.chunk'
        );
        return chunk[component];
    };
